import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-to-slow-down-a-gif";

export const Route = createFileRoute("/blog/how-to-slow-down-a-gif")(options);
